import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateBadgeAssigneeCreateLayoutRoute() {
  return <ModalStack />;
}
